import { Card } from 'antd';

const SystemUsers = () => {
  return (
    <Card title="系统用户管理">
      系统用户管理页面
    </Card>
  );
};

export default SystemUsers; 